import '@vaadin/password-field';
// eslint-disable-next-line no-duplicate-imports
import type {
    PasswordFieldValueChangedEvent,
    PasswordField as VaadinPasswordField,
} from '@vaadin/password-field';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { TmInputFieldBase } from './tm-input-field.base';

export const tagName = 'tm-password-field';
@customElement(tagName)
export class TmPasswordField extends TmInputFieldBase<string> {
    @property({ type: String })
    public allowedCharacters?: string;

    @property({ type: Number })
    public minLength?: number;

    @property({ type: Number })
    public maxLength?: number;

    @property({ type: Boolean })
    public passwordVisible?: boolean;

    private readonly passwordFieldRef = createRef<VaadinPasswordField>();

    protected validate() {
        if (!this.passwordFieldRef.value) {
            return false;
        }

        return this.passwordFieldRef.value.checkValidity();
    }

    protected render() {
        return html`
            <vaadin-password-field
                ${ref(this.passwordFieldRef)}
                @value-changed=${(e: PasswordFieldValueChangedEvent) => {
                    this.changeValue(e.detail.value);
                }}
                @focus=${(e: CustomEvent) => {
                    const focusEvent = new CustomEvent('focus', {
                        detail: e.detail,
                    });
                    this.dispatchEvent(focusEvent);
                }}
                part="component"
                class="w-full"
                label=${this.label}
                value=${this.initial || ''}
                placeholder=${ifDefined(this.placeholder)}
                allowed-char-pattern=${ifDefined(this.allowedCharacters)}
                .minlength=${this.minLength}
                .maxlength=${this.maxLength}
                ?required=${this.required}
                ?passwordVisible=${this.passwordVisible}
            >
            </vaadin-password-field>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmPasswordField;
    }
}
